/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import React, { useState } from "react";
import FormFader from "@/src/components/Form/Common/Fader/FormFader";
import wizardStyle from "@/src/components/Form/wizardStyle";
import { Box, Paper, Stack, Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import Typography from "@mui/material/Typography";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import { UpdateResourceParams } from "@/src/services/reactQuery/reactQueryService";
import { UseMutationResult } from "@tanstack/react-query";
import { Link } from "react-router";
import { translate } from "@/src/services/translations/translations";

type HardStopProps = {
  product: AbstractCase;
  reason: "uncovered" | "unconfident";
  updateMutation: UseMutationResult<any, unknown, UpdateResourceParams>;
};

export default function HardStop({ product, updateMutation, reason }: HardStopProps) {
  const [isLoading, setIsLoading] = useState(false);

  const resetProcess = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setIsLoading(true);
    updateMutation.mutateAsync({
      uri: "/pending_cases",
      id: product.id,
      data: { aiRefinementQuestions: null, refinementAnswers: null },
    });
    setIsLoading(false);
  };

  return (
    <Paper sx={wizardStyle.paper} elevation={4}>
      <FormFader>
        <Box component={"form"} sx={{ ...wizardStyle.applicationForm, ...wizardStyle.wizardForm }}>
          <Typography variant={"h4"} sx={[wizardStyle.headline, { display: { xs: "block", sm: "none" } }]}>
            {translate(`${product.name}.hardstop.${reason}.stepHeadline`, product)}
          </Typography>
          <Grid
            container
            sx={{
              justifyContent: "flex-start",
              alignItems: "baseline",
            }}
          >
            <Grid size={12}>
              <FormLegend>
                <strong>{translate(`${product.name}.hardstop.${reason}.stepHeadline`, product)}</strong>
              </FormLegend>
            </Grid>
            <Grid sx={wizardStyle.gridTopSpaced} size={12}>
              <FormLegend>{translate(`${product.name}.hardstop.${reason}.mainDescription`, product)}</FormLegend>
            </Grid>
            <Grid sx={{ my: 5 }} size={12}>
              <Stack spacing={2} sx={{ width: "100%", maxWidth: 420, mx: "auto" }}>
                <Button fullWidth variant="contained" color="primary" onClick={resetProcess} disabled={isLoading}>
                  Angaben korrigieren
                </Button>

                <Button fullWidth={true} component={Link} to={"/servicewelt"} variant={"text"} color={"primary"} disabled={isLoading}>
                  Zurück zur Übersicht
                </Button>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </FormFader>
    </Paper>
  );
}
